import lodash from 'lodash';
import {i18n} from "../../../vue-i18n";

export default class AddAssetComponent {
  constructor(assetComponent) {
    this.commandName = "AddAssetComponent";
    this.assetComponent = assetComponent;

    this.description = `${i18n.t('CONTENT.events.AddAssetComponent')}`;

    this.description =
      `${assetComponent.name} ${assetComponent.startDateDay}.${assetComponent.startDateMonth}.${assetComponent.startDateYear} - ${assetComponent.endDateDay}.${assetComponent.endDateMonth}.${assetComponent.endDateYear}`;
  }

  // Use this method to push this command to the server
  serialize() {
    const clone = lodash.clone(this.assetComponent);

    const serialisedCommand = JSON.stringify(clone);

    return {
      commandName: this.commandName,
      serialisedCommand: serialisedCommand
    }
  }

  equal() {
    // will always return false so user can add multiple payments
    return false;
  }
}
